import { render, staticRenderFns } from "./TravelRequirement.vue?vue&type=template&id=6f8b709d&scoped=true&"
import script from "./TravelRequirement.vue?vue&type=script&lang=js&"
export * from "./TravelRequirement.vue?vue&type=script&lang=js&"
import style0 from "./TravelRequirement.vue?vue&type=style&index=0&id=6f8b709d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b709d",
  null
  
)

export default component.exports